import { btns } from './buttons';

/**
 * The Quiet-Luxury form and table styles, shared across every managed surface.
 *
 * This object used to live in `src/pages/portfolio/forms.tsx`, which is still where
 * most of its callers import it from (that module re-exports it). It moved here when
 * the public, pre-auth intake page (docs/25 S4) needed the same look: importing it
 * from the portfolio module would have dragged the API client, the auth hook and the
 * asset-class tables into the bundle an unauthenticated visitor downloads, to use a
 * bag of class names. Style constants have no dependencies, so they get a home with
 * none either.
 */
export const cls = {
  header:    'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-8',
  h1:        'font-serif text-[28px] font-normal m-0 text-navy tracking-[-0.01em]',
  h2:        'font-serif text-xl font-normal m-0 mb-4 text-navy',
  h3:        'font-serif text-base font-normal m-0 mb-3 text-navy',
  ...btns,
  table:     'w-full min-w-[680px] border-collapse',
  th:        'text-left px-4 py-2.5 border-b border-line font-semibold text-slate text-[10px] uppercase tracking-[0.12em]',
  td:        'px-4 py-3.5 border-b border-line/60 text-body text-[13px] align-top',
  panel:     'bg-surface border border-line rounded-token p-6 mb-5 shadow-panel',
  label:     'block text-[10px] font-semibold text-slate mb-1.5 uppercase tracking-[0.1em]',
  input:     'w-full px-3 py-2 text-[13px] border border-line-strong rounded-token box-border bg-surface text-navy font-sans outline-none focus:border-bronze-strong focus:ring-1 focus:ring-bronze-strong max-sm:min-h-11',
  inputReadOnly: 'w-full px-3 py-2 text-[13px] border border-line rounded-token box-border bg-cream/60 text-slate font-sans cursor-default outline-none focus:border-bronze-strong focus:ring-1 focus:ring-bronze-strong max-sm:min-h-11',
  select:    'w-full px-3 py-2 text-[13px] border border-line-strong rounded-token box-border bg-surface text-navy font-sans focus:border-bronze-strong focus:ring-1 focus:ring-bronze-strong max-sm:min-h-11',
  textarea:  'w-full px-3 py-2 text-[13px] border border-line-strong rounded-token box-border resize-y bg-surface text-navy font-sans outline-none focus:border-bronze-strong focus:ring-1 focus:ring-bronze-strong',
  row:       'grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4',
  row3:      'grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4',
  field:     'mb-4',
  error:     'text-danger text-xs mt-2',
  back:      'text-slate cursor-pointer text-[10px] font-semibold border-none bg-transparent pb-6 block uppercase tracking-[0.12em] font-sans max-sm:min-h-11',
  section:   'mb-7',
  badge:     'inline-block text-[10px] font-bold px-2 py-0.5 rounded-token uppercase tracking-[0.08em] bg-bronze/[0.12] text-tag',
};
